import { Link } from "react-router-dom";
import StickyNavbar from "../navbar";
import QuizPopup from "./QuizPopup";
import React, { useState } from "react";
import { motion } from "framer-motion";

const DataCollection = () => {
  const [showQuiz, setShowQuiz] = useState(false);

  const handleQuizComplete = (answers) => {
    console.log("User answers:", answers);
    // You can process the answers here
  };

  return (
    <div>
      <StickyNavbar />
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="bg-white text-black p-4 lg:mt-10 mt-20 lg:text-lg sm:p-10 lg:px-20"
      >
        <motion.div
          initial={{ y: -50, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="space-y-3"
        >
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-center my-10 capitalize">
            Data Collection Tools
          </h2>
          <motion.h2
            initial={{ x: -50, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6 }}
            className="text-xl font-bold mb-2 text-[#005FFF]"
          >
            Data Collection
          </motion.h2>
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6 }}
          >
            Data collection is the way in which you collect your information
            from your chosen sample of participants. The way you collect your
            data can affect the type and depth of information you get (85-87).
          </motion.p>
          <motion.ul
            initial={{ x: -20, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6 }}
            className="list-disc list-inside space-y-3"
          >
            <li>
              <strong>Questionnaires:</strong> Questionnaires are simply a set of
              written questions you give to your participants for them to
              answer. This way of collecting data may be helpful when you have a
              bigger sample, or your participants are spread out further across
              the community. Using different types of questions make a good
              questionnaire, such as including ‘yes’ or ‘no’ questions, questions
              where participants have multiple choices they can choose from (for
              example, A, B or C), and open-ended questions where participants can
              use their own words in their answer.
            </li>
          </motion.ul>
        </motion.div>

        {/* Image Section for Questionnaires */}
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="rounded-lg p-4"
        >
          <div className="rounded-lg p-4">
            <div className="flex justify-center">
              <motion.img
                src="/images/questioniare.png"
                alt="Local leaders supporting research"
                className="w-full max-w-md rounded-md"
                initial={{ scale: 0.8, opacity: 0 }}
                whileInView={{ scale: 1, opacity: 1 }}
                viewport={{ once: true, amount: 0.5 }}
                transition={{ duration: 0.6 }}
              />
            </div>
            <motion.p
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6 }}
              className="text-center text-sm mt-2"
            >
              Wikimedia Community User Group Tanzania Group One Presenting. ©
              Ebenezer Mlay, used under CC BY-SA 4.0. Source:
            </motion.p>
          </div>
        </motion.div>

        <motion.ul
          initial={{ x: 20, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="list-disc list-inside space-y-3"
        >
          <li>
            <strong>Interviews:</strong> Interviews are a way to collect more
            detailed information by talking directly with people. In an
            interview, there are usually only two people: the interviewer and
            the interviewee. Interviewing allows us to ask questions so that
            participants can share their thoughts, experiences, and ideas. For
            this reason, they are usually used when doing qualitative research.
          </li>
        </motion.ul>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="space-y-3"
        >
          <motion.h2
            initial={{ x: -50, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6 }}
            className="text-xl font-bold mb-2 text-[#005FFF] my-10"
          >
            Types of interviews:
          </motion.h2>
          <motion.ul
            initial={{ x: 20, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6 }}
            className="list-decimal list-inside space-y-3"
          >
            <li>
              <strong>Structured interviews:</strong> If you are doing a structured
              interview, you ask the same set of questions to each person, in the
              same order. Doing it this way means you can compare answers between
              different participants more easily, and the process is normally a
              lot quicker.
            </li>
            <li>
              <strong>Unstructured interviews:</strong> If you are doing an
              unstructured interview, there is a bit more freedom over how the
              interview develops. You can ask follow-up questions based on what the
              person shares with you. This approach can be good in discovering new
              experiences, or ideas, that might not have come up if you were following a
              fixed set of questions.
            </li>
          </motion.ul>
        </motion.div>

        <motion.ul
          initial={{ x: -20, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="list-disc list-inside space-y-3 mt-10"
        >
          <li>
            <strong>Focus Groups:</strong> Focus groups are a way to collect
            information by having a group discussion with a small number of
            participants, often between 6–12 people. This method is useful when you
            want to understand a range of opinions, experiences, or ideas about a
            topic. Participants are encouraged to share their thoughts while also
            listening to others, which can bring out new views or ideas that may not
            come up in one-on-one interviews. Focus groups are often led by someone (such
            as the researcher) who guides the discussion and makes sure everyone has a
            chance to contribute. This method is especially helpful for exploring
            community-level issues or group experiences.
          </li>
        </motion.ul>

        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="rounded-lg p-4 mt-10"
        >
          <div className="flex justify-center">
            <motion.img
              src="/images/interviews.png"
              alt="Local leaders supporting research"
              className="w-full max-w-md rounded-md"
              initial={{ scale: 0.8, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              viewport={{ once: true, amount: 0.5 }}
              transition={{ duration: 0.6 }}
            />
          </div>
        </motion.div>

        <motion.ul
          initial={{ x: 20, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="list-disc list-inside space-y-3 mt-10"
        >
          <li>
            <strong>Checklists:</strong> Checklists are used in observational
            research. A checklist is a simple tool to keep track of what we observe
            in a structured way. When we are doing an observation, we use the checklist
            to know what behaviors or events to watch for, which can be marked off during
            an observation. This helps us collect information without having to write
            lots of notes. Using a checklist during an observation means all the observers
            are collecting the same type of information, making it easier to compare the
            results later on. If you were doing an observational study, you can create your
            own checklist based on the goals and objectives of your research and add to the
            list what behaviors you expect to see.
          </li>
        </motion.ul>

        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="rounded-lg p-4 mt-10"
        >
          <div className="flex justify-center">
            <motion.img
              src="/images/checklist.png"
              alt="Local leaders supporting research"
              className="w-full max-w-md rounded-md"
              initial={{ scale: 0.8, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              viewport={{ once: true, amount: 0.5 }}
              transition={{ duration: 0.6 }}
            />
          </div>
        </motion.div>

        {/* Navigation Buttons */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="flex justify-between mt-10"
        >
          <Link to="/chapter5">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-blue-900 text-white px-3 py-2 rounded-lg hover:bg-blue-700"
            >
              Previous
            </motion.button>
          </Link>
          <div className="flex justify-center">
            {/* Uncomment to add quiz button */}
            {/* <motion.button
              onClick={() => setShowQuiz(true)}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-white text-blue-800 border border-blue-800 px-6 py-2 rounded-lg"
            >
              Test Your Knowledge
            </motion.button> */}
          </div>
          <Link to="/chapter5/sectionTwo">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-blue-900 text-white px-3 py-2 rounded-lg hover:bg-blue-700"
            >
              Next
            </motion.button>
          </Link>
        </motion.div>
      </motion.div>
      {showQuiz && (
        <QuizPopup
          onClose={() => setShowQuiz(false)}
          onComplete={handleQuizComplete}
        />
      )}
    </div>
  );
};

export default DataCollection;
